import { numberPositive } from 'Data/validate.js'
import { FEE_MODE_RANGES } from 'Data/constants.js'

export function validateNumber(value) {
  return (
    numberPositive(value) &&
    value >= FEE_MODE_RANGES.SURCHARGE.CARD.MIN &&
    value <= FEE_MODE_RANGES.SURCHARGE.CARD.MAX
  )
}
